



























import Vue from "vue";
import { Component } from "vue-property-decorator";
import Game, { GameType } from "@/components/Game.vue";
import views from "@/views/Views";

@Component({
  components: {
    Game,
  },
})
export default class TreeSudokuOfFour extends Vue {
  type: GameType = GameType.TREESUDOKU;
  size = 4;
  title = views.find((el) => el.component === "TreeSudokuOfFour").title;
  args = { size: this.size };
  video = "treesudoku4.mp4";
}
